<template>
  <!-- tab 巡检设备 -->
  <div style="height: 420px;display:flex;">
    <div class="tableMin" style="margin-top: 20px; width: 35%;" v-if="showButton">
      <div class="left_title1">{{$t('label_140')}}</div>

      <el-table :empty-text="$t('label_357')" :data="tableData" height="350px" @current-change="tableCurrentChange" highlight-current-row border
                style="width: 100%;" @selection-change="handleChange"
                :header-cell-style="{'background-color': ' #EFEFEF','color': '#ffffff',}" :show-header="false">

        <el-table-column type="selection" width="40" align="center">
        </el-table-column>
        <el-table-column label="">
          <template slot-scope="scope">
            {{scope.row.superior}}<br>
            {{scope.row.tname}} {{scope.row.ename}}<br>
            {{scope.row.code}}<br>
          </template>
        </el-table-column>

        <el-table-column label="" align="center" width="55" v-if="showEdit">
          <template slot-scope="scope">
            <el-button @click="moveUp(scope.row, scope.$index)" :disabled="upDisabled(scope.$index)" type="text"
                       size="small" style="font-size: 20px"><i class="el-icon-arrow-up"></i>
            </el-button>
            <el-button @click="moveDown(scope.row, scope.$index)" :disabled="downDisabled(scope.$index)" type="text"
                       size="small" style="font-size: 20px;margin: 0"><i class="el-icon-arrow-down"></i>
            </el-button>
          </template>
        </el-table-column>

      </el-table>
    </div>

    <div style='width:20%;'  v-if="showButton">
      <div @click="leftadd"  v-if="showEdit"
           style='margin-top:150px;margin-right:20px;margin-left:30px;padding:5px 20px;background-color: #3fb393;color:#ffffff;font-weight: 600;text-align:center;cursor: pointer'>
        <i class="el-icon-d-arrow-left"></i></div>
      <div @click="rightadd"  v-if="showEdit"
           style='margin-top:80px;margin-right:20px;margin-left:30px;padding:5px 20px;background-color: #3fb393;color:#ffffff;font-weight: 600;text-align:center;cursor: pointer'>
        <i class="el-icon-d-arrow-right"></i></div>
    </div>
    <div class="tableBox9" style='position:unset; '  v-if="showButton">
      <div class="tableMes" >
        <div class="table" >
          <el-tabs v-model="activeNameTree" type="card" @tab-click="handleClickTree">
            <el-tab-pane :label="$t('label_429')" name="first">
              <tree :dataTree="treeData" :treeType="0" @getDeviceMes="getDeviceMes"  @getTreeList="getTreeList"></tree>
            </el-tab-pane>
            <el-tab-pane :label="this.$t('label_161')" name="second">
              <tree :dataTree="treeData2" :treeType="1" @getDeviceMes="getDeviceMes"  @getTreeList="getTreeList"></tree>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
  import utils from '@/utils/utils';
  import organizationTabJs from "@/assets/js/system/organizationTab.js";
  import menuTabJs from "@/assets/js/system/menuTab.js";
  import tree from "@/components/list/tree/inspectionTree";
  import file from "@/assets/js/file/file.js";
  import inspection from "@/assets/js/inspection/inspection.js";

  export default {
    name: "inspectionEquipment",
    components: {
      tree,
    },
    props: {
      showButton: {
        type: Boolean,
        default: false
      },
	  showEdit: {
		type: Boolean,
		default: true
	  }
    },
    data() {
      return {
        tableData: [],
        treeList: [],
        planList: {
          equipmentIdList: [],
          id: '',
          status: ''
        },
        tableHeight: 500,
        activeNameTree: 'first',
        treeShow: true,
        treeData: {
          dataDevice: [],
          searchShow: true,
          statusShow: true,
          statusListShow: true,
          cardShow: true,
          dataAll: true,
          funtoGetMes: '2'
        },
        treeData2: {
          dataDevice: [],
          searchShow: true,
          statusShow: true,
          statusListShow: true,
          cardShow: true,
          dataAll: true,
          funtoGetMes: '3'
        },
        getTreeMes: '0',
        newType: {
          name: '',
          operationState: '1',
          failureState: '1',
          lifeState: '1',
        },
      }
    },
    methods: {
      tableCurrentChange(row) {
      },
      upDisabled(index) {
        if (index == 0) {
          return true;
        } else {
          return false;
        }
      },
      downDisabled(index) {
        if (index === this.tableData.length - 1) return true;
        else return false;
      },
      handleClickTree(tab, event) {
        this.getTreeMes = '0';
        this.searchDataList = {}
        this.deviceDetailMes = {}
        this.deviceDetailMes.name = this.$t('label_272')
        this.search()
      },
      getDeviceList(id) {
        if (id == "") {
          this.tableData = [];
          return false
        }
        this.planList.id = id;
        let param = {
          id: id
        }
        inspection.selectDevice(param).then((response) => {
          const data = response.data;
          if (data.code == "1") {
            this.tableData = data.data
          }
        }).catch((response) => {
          console.log(response)
        })
      },
      moveUp(item, index) {
        inspection.sort1({
          id: item.id,
          sort: item.sort,
          id2: this.tableData[index - 1].id,
          sort2: this.tableData[index - 1].sort
        }).then((response) => {
          const data = response.data;
          if (data.code == 1) {
			this.getDeviceList(this.planList.id);
            this.$emit('reload');
          }
        }).catch((response) => {
          console.log(response)
        })
      },
      moveDown(item, index) {
        inspection.sort1({
          id: item.id,
          sort: item.sort,
          id2: this.tableData[index + 1].id,
          sort2: this.tableData[index + 1].sort
        }).then((response) => {
          const data = response.data;
          if (data.code == 1) {
			this.getDeviceList(this.planList.id);
            this.$emit('reload');
          }
        }).catch((response) => {
          console.log(response)
        })
      },
      leftadd() {
        this.planList.equipmentIdList = [];
        this.planList.status = '0';
        if (this.tableData.length > 0) {
          for (var item of this.treeList) {
            if (item.name != this.$t('label_272') && item.type.toString() == "1") {
              if (this.tableData.indexOf(item.id) == -1) {
                this.planList.equipmentIdList.push(item.id);
              }
            }
          }
        } else {
          for (var item of this.treeList) {
            console.log("-------------------------------------")
            console.log(item)
            if (item.name != this.$t('label_272') && item.type.toString() == "1") {
              this.planList.equipmentIdList.push(item.id);
            }
          }
        }
        inspection.inspDeviceAdd(this.planList).then((response) => {
          const data = response.data;
          if (data.code == "1") {
            this.getDeviceList(this.planList.id);
			this.planList.equipmentIdList = [];
          } else {
            utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
          }
        }).catch((response) => {
          console.log(response)
        })
      },
      rightadd() {
        this.planList.status = '1';
        inspection.inspDeviceAdd(this.planList).then((response) => {
          const data = response.data;
          if (data.code == "1") {
            this.getDeviceList(this.planList.id);
			this.planList.equipmentIdList = [];
          } else {
            utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
          }
        }).catch((response) => {
          console.log(response)
        })
      },
      handleChange(selection) {
        this.planList.equipmentIdList = [];
        // for (var item of this.tableData) {
        //   this.planList.equipmentIdList.push(item.equipmentId);
        // }
		console.log("测试"+this.planList.equipmentIdList);
        for (var i = 0; i < selection.length; i++) {
          this.planList.equipmentIdList.push(selection[i].equipmentId);
        }
		// console.log(this.planList.equipmentIdList);
      },
      getDeviceMes(data) {
        if (data.name == this.$t('label_272')) {
          this.getTreeMes = '0';
          this.searchDataList = {}
          this.deviceDetailMes = {}
          this.deviceDetailMes.name = this.$t('label_272')
          this.search();
          this.newType.equipmentTypeId = data.id;
        } else {
          this.deviceDetailMes = data;
          if (data.type == '1') {
            this.selectCard(data.id);
            this.getEquipmentParameter(data.id);
            // this.$nextTick(() => {
            //   this.$refs.checkItemDisplay.newMes(data.id);
            //   this.$refs.maintenanceItemDisplay.newMes(data.id);
            //   this.$refs.inspectionItemDisplay.newMes(data.id, 0);
            //   this.$refs.electronDocumentDisplay.newMes(data.id);
            //   this.$refs.partInfoDisplay.newMes(data.id);
            //   this.searchDeviceMesDetail();
            // })
            this.getTreeMes = '3';
          } else if (data.type == '2') {
            this.newType.deptId = data.id;
            this.getTreeMes = '0';
            this.searchDataList = {
              areaId: data.id
            }
            this.search();
          } else if (data.type == '0') {
            this.newType.equipmentTypeId = data.id;
            this.getTreeMes = '0';
            this.searchDataList = {
              deviceId: data.id
            }
            this.search();
          }
        }
      },
      getTreeList(data) {
        console.log(data)
        this.treeList = data;
      },
      search() {
        let param = {
          pageNum: 1,
          pageSize: 10,
        }
        this.searchPage(param);
      },
      searchPage(param) {
        var dataParam = this.searchDataList;
        var newParam = Object.assign(param, dataParam);
        // this.getEquipmentInfoPageList(newParam)
        // this.getEquipmentInfoPageStatusList(newParam)
      },
      getEquipmentInfoPageList(newParam) {
        file.getEquipmentInfoPageList(newParam).then((response) => {
          const data = response.data;
          if (data.code == "1") {
            this.tableDataDeviceList = data.data.records;
            this.pageSize = data.data.size;
            this.pageCount = data.data.total;
            this.pageNum = data.data.current;
            this.$refs['pageModel'].setCurrent(this.pageNum);
          }
        }).catch((response) => {
          console.log(response)
        })
      },
      getEquipmentInfoPageStatusList(newParam) {
        file.getEquipmentInfoPageStatusList(newParam).then((response) => {
          const data = response.data;
          if (data.code == "1") {
            this.equipmentStatusList = data.data
          }
        }).catch((response) => {
          console.log(response)
        })
      },
    },
    created() {
    },
    mounted() {
    }
  }
</script>
<style scoped>
  .left_title1 {
    width: 100%;
    height: 30px;
    line-height: 30px;
    background: #EFEFEF;
    font-weight: 600;
    padding-left: 10px;
    box-sizing: border-box;
  }

  >>> .el-autocomplete {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/list/displayPage/inspectionEquipment.vue